import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import AddEditRoleModal from './Add_Edit/AddEditRoleModal';
import DeleteRoleModal from './Delete/DeleteRoleModal';
import { getRolesList } from '../../../slices/thunks';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const RolesList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const rolesListSelector = createSelector(
		state => state.Roles.roleList,
		roleList => roleList
	);

	const rolesList = useSelector(rolesListSelector);

	useEffect(() => {
		dispatch(getRolesList());
	}, []);

	const [dataRole, setDataRole] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Role
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = role => {
		setDataRole(role);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = role => {
		setDataRole(role);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false, enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				columnDefType: 'display',
				
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const roleData = cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(roleData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const roleData = cellProps.row.original;
													handleClickDelete(roleData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Nombre',
				accessorKey: 'name',
			},
			{
				header: 'Código',
				accessorKey: 'code',
			},
			{
				header: 'Descripción',
				accessorKey: 'description',
			},
			{
				header: 'Nro. Permisos',
				accessorFn: row => row.scopes.length,
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<div className='row'>
				<Col lg={12}>
					<div className='card'>
						{/* <div className='card-header border-0'>
							<div className='d-flex align-items-center'>
								<h5 className='card-title mb-0 flex-grow-1'>
									Administración de Perfiles
								</h5>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataRole({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Perfil
										</button>
									</div>
								</div>
							</div>
						</div> */}
						<div className='card-body pt-3'>
							{/* {isLoadingList ? (
								<Alert color='primary'>
									<Spinner size='sm' className='me-2' />
									Cargando datos, por favor espere...
								</Alert>
							) : null} */}
							<ODataGrid 
								columns={columns} 
								data={rolesList || []} 
								nameFile={'perfiles'} 
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										className: 'gap-1',
										onClick: () => {
												setIsEdit(false);
												setDataRole({});
												handleToggleModal();
										},
										title: 'Crear Perfil',
									}
								]}
							/>
						</div>
					</div>
				</Col>
			</div>

			<AddEditRoleModal
				dataRole={dataRole}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteRoleModal
				dataRole={dataRole}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default RolesList;
